import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import makeStyles from '@mui/styles/makeStyles';
import { Container, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import API from "../utils/API";
import Grid from "@mui/material/Grid";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Radio from "@mui/material/Radio";

import { DataGrid } from "@material-ui/data-grid";
import Box from "@mui/material/Box";
//import { CircularProgress } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      // width: "30ch",
      margin: theme.spacing(1),
      flexGrow: 1,
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  formControl: {
    margin: theme.spacing(0.5),
    minWidth: 220,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  buttons: {
    minWidth: "10rem",
  },

  btn: {
    minWidth: "6rem",
  },

  tableRow: {
    height: 30,
  },
  tableCell: {
    padding: "8px 17px 25px 17px",
  },
}));

const styles = {
  mobilenumber: {
    marginRight: 70,
    marginTop: -20,
    position: "relative",
  },
  mobileform: {
    marginBottom: -20,
    marginLeft: -230,
  },
  button: {
    minWidth: 150,
    transform: "translate(-20%,-42%)",
  },
  calltypebox: {
    display: "block",
    marginLeft: -260,
  },
  calltype: {
    minWidth: 160,
    // marginLeft:-35,
    // marginTop:20,
  },
  menuitem: {
    fontSize: 15,
    backgroundColor: "red",
  },
  customertable: {
    marginTop: -300,
    marginLeft: 850,
    marginBottom: 100,
  },
  infotable: {
    minWidth: "145%",
  },
};

function CrmOutbound() {
  const [customerservices, setCustomerservices] = useState({});
  const [leadReport, setLeadReport] = useState({});
  //const [notContacted, setNotContacted] = useState({});
  //const [notInterested, setNotInterested] = useState({});
  const [interactionhistory, setInteractionhistory] = useState({});

  const [id, setId] = useState("");
  const [entered, setEntered] = useState(false);
  const [idFromButtonClick, setIdFromButtonClick] = useState("");
  const classes = useStyles();
  const history = useHistory();
  const handleClick = () => {
    if (id === "") {
      alert("Please Enter Mobile Number ");
    } else {
      setIdFromButtonClick(id);
      setTimeout(() => {
        setEntered(true);
      }, 500);

      setCustomerservices({});
      //setNotContacted({});
      //setNotInterested({});
      setInteractionhistory({});
    }
  };

  {
    /* const [selectedValue, setSelectedValue] = React.useState("a");

  const handleChangeradio = (event) => {
    setSelectedValue(event.target.value);
  };


  var path = {};

  if (selectedValue === "a") {
    path = {
      pathname: "/crmoutbound",
      state: {


      },
    };
  } else if (selectedValue === "c") {
    path = {
      pathname: "/crmInbound",
      state: {


      },
    };
  }*/
  }

  {
    /*function combineArray(notInterested, notContacted, leadReport) {
    return [].concat(notInterested, notContacted, leadReport);
  }*/
  }

  const options = { month: "long", day: "numeric", year: "numeric" };

  const dateFormatter = new Intl.DateTimeFormat("en-GB", options);

  ////////////// Lead Report //////////////////

  const leadColumns = [
    { field: "id", headerName: "ID", width: 100 },
    {
      field: "cHead",
      headerName: "Category Head",
      width: 200,
      valueFormatter: (value) => value.row?.cHead?.name,
    },
    {
      field: "cat",
      headerName: "Category",
      width: 200,
      valueFormatter: (value) => value.row?.cat?.name,
    },
    {
      field: "subCat",
      headerName: "SubCategory",
      width: 200,
      valueFormatter: (value) => value.row?.subCat?.name,
    },
    {
      field: "leadCategoryId",
      headerName: "Lead Type",
      width: 140,
      valueFormatter: (value) => value.row?.leadCategory?.name,
    },
    {
      field: "date",
      headerName: "Entry Date",
      width: 200,
      valueFormatter: ({ value }) => dateFormatter.format(new Date(value)),
    },

    // { field: "discountValue", headerName: "Discount Value", width: 160},
    {
      field: "callbackDate",
      headerName: "Callback Date",
      width: 200,
      valueFormatter: ({ value }) => dateFormatter.format(new Date(value)),
    },
    {
      field: "customerName",
      headerName: "Customer Name",
      width: 200,
      valueFormatter: (value) => value.row?.cm?.customerName,
    },
    {
      field: "customerNumber",
      headerName: "Customer Mobile",
      width: 200,
      valueFormatter: (value) => value.row?.cm?.customerNumber,
    },
    {
      field: "createdPerson",
      headerName: "Created By",
      width: 150,
      valueFormatter: (value) => value.row?.createdPerson?.name,
    },
    { field: "remarks", headerName: "Remarks", width: 200 },
  ];

  ////////// combine /////////////////

  const columns = [
    { field: "id", headerName: "Id", width: 100 },
    {
      field: "issueType",
      headerName: "Response",
      width: 200,
      valueFormatter: (value) => value.row?.issueType?.name,
    },
    { field: "customerNumber", headerName: "Customer Number", width: 250 },
    {
      field: "createdAt",
      headerName: "Creation Date",
      width: 150,
      valueFormatter: ({ value }) => dateFormatter.format(new Date(value)),
    },
    {
      field: "createdPerson",
      headerName: "Created By",
      width: 150,
      valueFormatter: (value) => value.row?.createdPerson?.name,
    },
    { field: "remarks", headerName: "Remarks", width: 200 },
  ];

  //////////////////////////////////////////////

  var count = 0;

  useEffect(() => {
    const storedToken = localStorage.getItem("tokenStore");

    if (!storedToken) {
      history.push("/");
    }

    if (id !== "") {
      API({
        url: `customer/${id}`,
        headers: { Authorization: `Bearer ${storedToken}` },
      })
        .then((res) => {
          console.log(res);
          setCustomerservices(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // eslint-disable-next-line
  }, [idFromButtonClick]);

  useEffect(() => {
    const storedToken = localStorage.getItem("tokenStore");

    if (!storedToken) {
      history.push("/");
    }

    if (id !== "") {
      API({
        url: `interactionhistory/${id}`,
        headers: { Authorization: `Bearer ${storedToken}` },
      })
        .then((res) => {
          console.log(res);
          const combined = [].concat(
            res.data.notInterested,
            res.data.notContacted
          );
          console.log(combined);

          //setNotContacted(res.data.notContacted);
          //setNotInterested(res.data.notInterested);
          setInteractionhistory(combined);
          setLeadReport(res.data.leadReport);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // eslint-disable-next-line
  }, [idFromButtonClick]);

  const reverse = (str) => {
    var splitString = str.split("-");

    var reverseArray = splitString.reverse();

    var joinArray = reverseArray.join("-");

    return joinArray;
  };

  const mapToId = (interactionhistory) =>
    interactionhistory.map((row) => {
      const { issueId, ...rest } = row;
      return { id: issueId, ...rest };
    });

  return (
    <div>
      <Container>
        <h1> Please Select Interaction Type </h1>

        <Button
          variant="contained"
          color="secondary"
          className={classes.btn}
          style={{ marginTop: "-15", marginLeft: -20, width: 60 }}
          size="medium"
        >
          <Link
            to={{
              pathname: "/outbound",
              state: {
                phonenumber: id,
              },
            }}
            key="/outbound"
            style={{ textDecoration: "none", color: "white" }}
          >
            Outbound
          </Link>
        </Button>

        <Button
          variant="contained"
          color="secondary"
          className={classes.buttons}
          style={{ marginTop: "-15", marginLeft: 20, minWidth: 60 }}
          size="medium"
        >
          <Link
            to={{
              pathname: "/crm-inbound",
              state: {
                phonenumber: id,
              },
            }}
            key="/crm-inbound"
            style={{ textDecoration: "none", color: "white" }}
          >
            INBOUND
          </Link>
        </Button>
      </Container>

      <br />
    </div>
  );
}
export default CrmOutbound;

{
  /* input number field and lead options */
}

{
  /* <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={10}>
            <form
              className={classes.root}
              noValidate
              autoComplete="off"
              style={styles.mobileform}
              onSubmit={(e) => e.preventDefault()}
            >

              <TextField
                id="outlined-basic"
                label="Enter Mobile Number"
                variant="outlined"
                aria-describedby="my-helper-text"
                type="text"
                style={styles.mobilenumber}
                value={id}
                onChange={(e) => setId(e.target.value)}
              />

              {/* submit button
              <Button
                type="submit"
                variant="contained"
                color="primary"
                onClick={handleClick}
                style={styles.button}
              >
                Submit
              </Button>

              <br />

              {/*<h2>CRM OUTBOUND</h2>*/
}

{
  /* <br /> */
}

{
  /* call type */
}

{
  /*<InputLabel
                id="demo-simple-select-label"
                style={{ marginLeft: -350, marginBottom: 30, marginTop: 20 }}
              >
                Call-Type
              </InputLabel>
              <FormControl
                className={classes.formControl}
                style={styles.calltypebox}
              >
                <Select
                  native
                  value="OutBound"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  // onChange={handleChange}
                  name="Call-Type"
                  style={styles.calltype}
                >
                  <option key="1" value="Out Bond" style={styles.menuitem}>
                    Outbound
                  </option>
                </Select>
              </FormControl>*/
}

{
  /*    <br />

      <div className={classes.formControl} style={{ marginLeft: -150 }}>
        <Radio
          checked={selectedValue === "a"}
          onChange={handleChangeradio}
          value="a"
          name="radio-button-demo"
          inputProps={{ "aria-label": "A" }}
          color="primary"
          label="Outbound"
        />
        <span style={{ marginRight: 20 }}>Outbound</span>

        <Radio
          checked={selectedValue === "c"}
          onChange={handleChangeradio}
          value="c"
          name="radio-button-demo"
          inputProps={{ "aria-label": "C" }}
          color="primary"
          label="Inbound"
        />
        Inbound
      </div>

      <br />
      <br />

      <Button variant="contained" color="primary" style={{ marginLeft: -20 }}>
        {selectedValue !== "b" ? (
          <Link to={path} style={{ textDecoration: "none", color: "white" }}>
            Next
          </Link>
        ) : (
          <a

          >
            Next
          </a>
        )}
      </Button>




      <br />
            </form>
          </Grid>
          {entered ? (
            <Grid
              item
              xs={4}
              style={{ marginLeft: 295, display: "flex", flexWrap: "wrap" }}
            >
              <Button
                variant="contained"
                color="primary"
                className={classes.buttons}
                style={{ marginTop: "5%", minWidth: "15em" }}
                size="medium"
                onClick={(e) => {
                  e.preventDefault();
                  // window.location.href = "https://repairadda.com/";
                  const url = "https://repairadda.com/";
                  window.open(url, "_blank");
                }}
              >
                New service
              </Button>
              <br />
              <Button
                variant="contained"
                color="primary"
                className={classes.buttons}
                style={{ marginTop: "5%", marginLeft: 20, width: 200 }}
                size="medium"
              >
                <Link
                  to={{
                    pathname: "/leadgenerations",
                    state: {
                      phonenumber: id,
                    },
                  }}
                  key="leadgeneration"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  Lead generation
                </Link>
              </Button>
              <br />
              <Button
                variant="contained"
                color="primary"
                className={classes.buttons}
                style={{ marginTop: "5%", minWidth: "15em" }}
                size="medium"
              >
                <Link
                  to={{
                    pathname: "/notcontactedusers",
                    state: {
                      phonenumber: id,
                    },
                  }}
                  key="notcontacted"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  Not contacted
                </Link>
              </Button>
              <br />
              <Button
                variant="contained"
                color="primary"
                className={classes.buttons}
                style={{ marginTop: "5%", marginLeft: 20, minWidth: 200 }}
                size="medium"
              >
                <Link
                  to={{
                    pathname: "/notinterestedusers",
                    state: {
                      phonenumber: id,
                    },
                  }}
                  key="notinterested"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  Not interested
                </Link>
              </Button>
              <br />
              {/*<Button
                variant="contained"
                color="primary"
                className={classes.buttons}
                style={{ marginTop: "5%",marginLeft: 5, width: 200 }}
                size="medium"
              >
                <Link
                  to={{
                    pathname: "/inboundLeadgenerations",
                    state: {
                      phonenumber: id,
                    },
                  }}
                  key="inboundLeadgenerations"
                  style={{ textDecoration: "none", color: "white" }}
                >
                 Inbound Lead
                </Link>
              </Button>
              <br />
              <Button
                variant="contained"
                color="primary"
                className={classes.buttons}
                style={{ marginTop: "5%", marginLeft: 25, minWidth: 200 }}
                size="medium"
              >
                <Link
                  to={{
                    pathname: "/inboundSource",
                    state: {
                      phonenumber: id,
                    },
                  }}
                  key="inboundSource"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  INBOUND SOURCE
                </Link>
              </Button>
              <br />
              <br />
              <Button
                variant="contained"
                color="primary"
                className={classes.buttons}
                style={{ marginTop: "5%",marginLeft: 5, width: 200 }}
                size="medium"
              >
                <Link
                  to={{
                    pathname: "/crmInbound",
                    state: {
                      phonenumber: id,
                    },
                  }}
                  key="CrmInbound"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  INBOUND BRANCH
                </Link>
              </Button>
              <br />
            </Grid>
          ) : (
            ""
          )}
        </Grid>
      </div>

      {/* details info table */
}

{
  /* view services table */
}

{
  /* <TableContainer
        component={Paper}
        style={{ width: "87%", marginLeft: "15rem", marginTop: 70 }}
      >
        <Table
          // className={classes.table}
          // size="large"
          style={styles.infotable}
          aria-label="a dense table"
        >
          {customerservices.length > 0 && (
            <TableHead>
              <h4>BOOKED SERVICES</h4>
              <TableRow className={classes.tableRow}>
                <TableCell className={classes.tableCell} align="right">
                  <b>ID</b>
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.tableCell}
                  style={{ width: 150, transform: "translateY(23%)" }}
                >
                  <b>Token Date</b>
                  <p>
                    <b>(dd-mm-yy)</b>
                  </p>
                </TableCell>
                <TableCell className={classes.tableCell} align="right">
                  <b>Token Number</b>
                </TableCell>
                <TableCell align="right" className={classes.tableCell}>
                  <b>Customer Name</b>
                </TableCell>
                <TableCell align="right" className={classes.tableCell}>
                  <b>Customer Number</b>
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.tableCell}
                  style={{ textAlign: "left" }}
                >
                  <b>Service/Product</b>
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.tableCell}
                  style={{ textAlign: "center" }}
                >
                  <b>Customer Address</b>
                </TableCell>
                <TableCell align="right" className={classes.tableCell}>
                  <b>Lead Source</b>
                </TableCell>
                <TableCell align="right" className={classes.tableCell}>
                  <b>Sales Person</b>
                </TableCell>
                <TableCell align="right" className={classes.tableCell}>
                  <b>Vendor Name</b>
                </TableCell>
                <TableCell align="right" className={classes.tableCell}>
                  <b>Status Marked</b>
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.tableCell}
                  style={{ transform: "translateY(23%)" }}
                >
                  <b>Status Marked Date</b>
                  <p style={{ transform: "translateX(-20%)" }}>
                    <b>(dd-mm-yy)</b>
                  </p>
                </TableCell>
              </TableRow>
            </TableHead>
          )}

          <TableBody>
            {customerservices.length > 0 &&
              customerservices.map((y) => (
                <TableRow key={count}>
                  <TableCell align="right">{++count}</TableCell>
                  <TableCell align="right">
                    {reverse(y.tokenDate.split("T")[0])}
                  </TableCell>
                  <TableCell align="right" style={{ textAlign: "left" }}>
                    {y.tokenNumber}
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    align="right"
                    style={{ textAlign: "center" }}
                  >
                    {y.customerName}
                  </TableCell>
                  <TableCell align="right" style={{ textAlign: "center" }}>
                    {y.customerNumber}
                  </TableCell>
                  <TableCell align="right" style={{ textAlign: "left" }}>
                    {y.goodsServiceName}
                  </TableCell>
                  <TableCell align="right" style={{ textAlign: "center" }}>
                    {y.customerAddress}
                  </TableCell>
                  <TableCell align="right" style={{ textAlign: "center" }}>
                    {y.leadSource}
                  </TableCell>
                  <TableCell align="right" style={{ textAlign: "center" }}>
                    {y.salesPerson}
                  </TableCell>
                  <TableCell align="right" style={{ textAlign: "center" }}>
                    {y.companyName}
                  </TableCell>
                  <TableCell align="right" style={{ textAlign: "center" }}>
                    {y.statusMarked}
                  </TableCell>
                  <TableCell align="right" style={{ textAlign: "center" }}>
                    {reverse(y.statusMarkedDate)}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box alignItems="center" style={{ width: "87%", marginLeft: "15rem" }}>
        <div
          style={{
            height: 400,
            width: "90%",
            background: "transparent",
            color: "black",
            marginTop: 20,
            marginLeft: 10,
          }}
        >
          {interactionhistory.length > 0 && (
            <DataGrid
              rows={mapToId(interactionhistory)}
              columns={columns}
              pageSize={10}
              sortingOrder={["asc", "desc"]}
              sortModel={[
                {
                  field: "id",
                  sort: "desc",
                },
              ]}
            />
          )}

          <div
            style={{
              height: 450,
              width: "100%",
              background: "transparent",
              color: "black",
              marginTop: 20,
              marginLeft: 0,
            }}
          >
            {leadReport.length > 0 && (
              <DataGrid
                rows={leadReport}
                columns={leadColumns}
                pageSize={10}
                sortingOrder={["desc", "asc"]}
                sortModel={[
                  {
                    field: "id",
                    sort: "desc",
                  },
                ]}
              />
            )}
          </div>
        </div>
      </Box>
    </div> */
}
